'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'circle-dollar';
var width = 512;
var height = 512;
var aliases = ["dollar-circle","usd-circle"];
var unicode = 'f2e8';
var svgPathData = ['M48 256a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zm128-41.4c0-32.3 24.5-58.9 56-62.2l0-8.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-57.4 0c-8 0-14.6 6.5-14.6 14.6 0 7.2 5.3 13.4 12.5 14.4l45.8 6.5c30.8 4.4 53.7 30.8 53.7 61.9 0 32.3-24.5 58.9-56 62.2l0 8.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l65.4 0c8 0 14.6-6.5 14.6-14.6 0-7.2-5.3-13.4-12.5-14.4l-45.8-6.5c-30.8-4.4-53.7-30.8-53.7-61.9z', 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-368c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8.3c-31.5 3.3-56 29.9-56 62.2 0 31.1 22.9 57.5 53.7 61.9l45.8 6.5c7.2 1 12.5 7.2 12.5 14.4 0 8-6.5 14.6-14.6 14.6L208 312c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8.3c31.5-3.3 56-29.9 56-62.2 0-31.1-22.9-57.5-53.7-61.9L236.5 229c-7.2-1-12.5-7.2-12.5-14.4 0-8 6.5-14.6 14.6-14.6l57.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;